export default (axios, baseURL) =>
  async (clientSid, queryParam = {}) => {
    const url = `/v2/clients/${clientSid}/student-groups/vendor`;
    const axiosConfig = {
      method: 'GET',
      baseURL,
      url,
      headers: {
        'x-impersonated-client-sid': clientSid
      },
      params: queryParam
    };
    const axiosResponse = await axios(axiosConfig);
    if (!axiosResponse || !Array.isArray(axiosResponse.data)) {
      throw new Error('Invalid response from gateway');
    }
    return axiosResponse.data;
  };
